import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { subscribeUnauthorized } from "@/lib/unauthorized";

export function useUnauthorizedWatcher() {
  const queryClient = useQueryClient();
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    function handleUnauthorized() {
      queryClient.clear();
      setSessionExpired(true);
    }
    return subscribeUnauthorized(handleUnauthorized);
  }, [queryClient]);

  function acknowledge() {
    setSessionExpired(false);
  }

  return { sessionExpired, acknowledge };
}
